jQuery(function ($) {
    $('.nhsuk-highlight a, .component-visit-nhsuk-infobar a').click(function (event) {
        if (typeof ga !== 'undefined') {
          var p = new Promise(function (resolve, reject) {
            setTimeout(function () {
              reject(new Error('ga hitCallback failed'))
            }, 500);
            ga('send', 'event', 'NHS.UK Promo', 'click', event.currentTarget.text, {
              'transport': 'beacon',
              'hitCallback': resolve,
            })
          })

          // Execute the promise
          p.finally(function () {
            // do nothing
          })
        }
    })
})
